export { default as EmptyCart } from './EmptyCart'



// WEBPACK FOOTER //
// ./src/modules/persistent-cart/emptyCart/index.js